import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/types';

export const selectDiscounts = createSelector(
  (state: RootState) => state.discountReducer.discounts,
  (discounts) => discounts,
);
